import React from "react";
import "../styles/prescriptions/questionnaireResponseCard.css";

interface QuestionData {
  header: string;
  description?: string;
}

interface QuestionnaireResponse {
  id: string;
  answers: Record<string, any>;
  questionnaireSnapshot: Record<string, QuestionData>;
}

interface Props {
  response: QuestionnaireResponse | null;
}

const QuestionnaireResponseCard: React.FC<Props> = ({ response }) => {
  if (!response) {
    return <p>No questionnaire response available.</p>;
  }

  const { questionnaireSnapshot, answers } = response;
  const questionKeys = Object.keys(questionnaireSnapshot);

  if (questionKeys.length === 0) {
    return <p>No questions found in the snapshot.</p>;
  }

  return (
    <div className="questionnaire-card">
      <h2>Questionnaire Responses</h2>
      {questionKeys.map((key, index) => {
        const question = questionnaireSnapshot[key];
        const answer = answers ? answers[key] : undefined;
        return (
          <div key={key} style={{ marginBottom: "16px" }}>
            <h4>{question.header}</h4>
            {/* Uncomment if you want to display the description:
            {question.description && <p>{question.description}</p>} */}
            <p>
              <strong>Answer:</strong>{" "}
              {answer !== undefined
                ? typeof answer === "object"
                  ? JSON.stringify(answer, null, 2)
                  : answer
                : "No answer provided"}
            </p>
            {index < questionKeys.length - 1 && (
              <hr style={{ border: "1px solid #ccc" }} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default QuestionnaireResponseCard;
